import { PublishedVersionsState, PublishedVersionsFetchStatus, AgentCommissionVersion } from "app/pages/AgentPricing/modules/PublishedVersions/state";

function getRoot(state: any) : PublishedVersionsState {
    return state.publishedVersions;
}

export function getPublishedVersionsFetchStatus(state: any) : PublishedVersionsFetchStatus {
    return getRoot(state).status; 
}

export function getPublishedAgentCommission(state: any) : AgentCommissionVersion[] {
    return getRoot(state).versions; 
}

export function showPublishedVersionDialog(state: any) : boolean {
    return getRoot(state).selected !== ''; 
}

export function getSelectedPublishedVersion(state: any) : AgentCommissionVersion | undefined {
    const versionCode = getRoot(state).selected; 
    if (versionCode === '')
        return undefined; 

    return getRoot(state).versions.find(x => x.rates.versionCode === versionCode); 
}